<div fxLayout="row" fxLayoutAlign='space-between center'>
	<h3 appMargin marginB="0">Company Details</h3>
	<button (click)="edit()" class="ui tiny icon button" >
		<i class="pencil icon"></i>
		</button>
	</div>
	<hr>

<div class="ui vertical basic segment">
		<div fxLayout="row" fxLayoutAlign='start center'>
		<div fxFlex="40%"><img src="assets/avatar/1.jpg" class="ui tiny image"/></div>
		<div fxFlex="grow"><button class="ui  button" (click)="changeLogo()">Change Logo</button></div>
	</div>
	<div class="ui divider"></div>

	<div fxLayout="row">
		<div fxFlex="40%"><strong>RC Number</strong></div>
		<div fxFlex="grow">5069876354.</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="40%"><strong>Tax Identification Number</strong></div>
		<div fxFlex="grow">9385023JF.</div>
	</div>
	<div class="ui divider"></div>


		<div fxLayout="row">
		<div fxFlex="40%"><strong>Address</strong></div>
		<div fxFlex="grow">4140 Parker Rd. Allentown, New Mexico 31134</div>
	</div>
	<div class="ui divider"></div>


		<div fxLayout="row">
		<div fxFlex="40%"><strong>Main Contact</strong></div>
		<div fxFlex="grow">Farida Aliyu.</div>
	</div>
	<div class="ui divider"></div>


		<div fxLayout="row">
		<div fxFlex="40%"><strong>Email</strong></div>
		<div fxFlex="grow">tim.jennings@example.com</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="40%"><strong>Phone Number</strong></div>
		<div fxFlex="grow">0907 315 6551.</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="40%"><strong>Website</strong></div>
		<div fxFlex="grow">www.lionbrand.com</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="40%"><strong>Company Type</strong></div>
		<div fxFlex="grow">Limited Liability</div>
	</div>
	<div class="ui divider"></div>

		<div fxLayout="row">
		<div fxFlex="40%"><strong>Ownership Type</strong></div>
		<div fxFlex="grow">Partnership</div>
	</div>
	<div class="ui divider"></div>

</div>
